<div
  *ngIf="environment.isDevelopmentBuild() && false"
  class="flex justify-between items-center p-2 bg-yellow-300 mb-2"
>
  <span
    >Payments are not available in development build. isPro:
    {{ authService.isProForDevelopment }}.</span
  ><button
    mat-flat-button
    (click)="authService.isProForDevelopment = !authService.isProForDevelopment"
  >
    Switch
  </button>
</div>
<ng-content *ngIf="authService.isPro; else upsell">
  <settings-for-prefund-pro-thank-you></settings-for-prefund-pro-thank-you>
</ng-content>
<ng-template #upsell>
  <settings-for-prefund-pro-upsell></settings-for-prefund-pro-upsell>
</ng-template>
